import { UTMModule } from "@/store/modules/utm.store";
import { IReportHomeQueryParams } from "../interfaces/Report/IReportHomeQueryParams";

/**
 * The six UTM parameters as defined by the Urchin Tracking Module convention.
 *
 * Shared by the report and thg query parameter lists so that a campaign link
 * lands the same attribution data in the store regardless of which funnel it
 * points at.
 *
 * @see https://en.wikipedia.org/wiki/UTM_parameters
 */
export const utmQueryParams: IReportHomeQueryParams[] = [
  {
    key: "utm_source",
    onFound: (value: string) => UTMModule.setSource(value),
    get: () => UTMModule.utm.utm_source || ""
  },
  {
    key: "utm_medium",
    onFound: (value: string) => UTMModule.setMedium(value),
    get: () => UTMModule.utm.utm_medium || ""
  },
  {
    key: "utm_campaign",
    onFound: (value: string) => UTMModule.setCampaign(value),
    get: () => UTMModule.utm.utm_campaign || ""
  },
  {
    key: "utm_id",
    onFound: (value: string) => UTMModule.setId(value),
    get: () => UTMModule.utm.utm_id || ""
  },
  {
    key: "utm_term",
    onFound: (value: string) => UTMModule.setTerm(value),
    get: () => UTMModule.utm.utm_term || ""
  },
  {
    key: "utm_content",
    onFound: (value: string) => UTMModule.setContent(value),
    get: () => UTMModule.utm.utm_content || ""
  }
];
